import { Injectable } from '@angular/core';

import { State } from '@shure/shared/models';

export interface TabState {
	activeTabDeviceId: string;
	hasUnsavedChanges: boolean;
}

@Injectable({ providedIn: 'root' })
export class DeviceUiPageStateService {
	public readonly state = new State<TabState>({
		activeTabDeviceId: '',
		hasUnsavedChanges: false
	});

	public setActiveTabDeviceId(activeTabDeviceId: string): void {
		this.state.update(<Partial<TabState>>{ activeTabDeviceId });
	}

	public setHasUnsavedChanges(hasUnsavedChanges: boolean): void {
		this.state.update(<Partial<TabState>>{ hasUnsavedChanges });
	}
}
